'use strict';

var _ = require('lodash');
var WorkflowSettingsConfigService = function WorkflowSettingsConfigService(FeatureToggleService) {
  var workflowData = require('../config/workflow-settings.json');
  var dashboardCellRenderer = function dashboardCellRenderer() {
    return '<rm-combobox class="{{data.title}}" item-list="data.options" fixed-position="true" ng-model="data.value"></rm-combobox>';
  };
  var marketAnalysisCellRenderer = function marketAnalysisCellRenderer() {
    //use ngswitch here to toggle between combobox and numeric entry
    return '<div ng-switch="data.title">' + '       <form xt-form strategy="submittedOrTouched" ng-switch-when="defaultSearchDays">' + '           <input xt-validation-tooltip="" validate="true" msg-min="Value must be between 0 and 365" msg-max="Value must be between 0 and 365" ' + '               placement="top" type="number" pattern="^[0-9]+(\.[0-9]+)*?$" min="0" max="365" ng-model="data.value.id" ' + '               class="{{data.title}} rm-ag-grid-input" container="#workflow-settings-tooltip">' + '       </form>' + '       <rm-combobox class="{{data.title}}" item-list="data.options" fixed-position="true" ng-model="data.value" ng-switch-default></rm-combobox>' + '</div>';
  };
  var flightAnalysisCellRenderer = function flightAnalysisCellRenderer() {
    //use ngswitch here to toggle between combobox and numeric entry
    return '<div ng-switch="data.title">' + '       <form xt-form strategy="submittedOrTouched" ng-switch-when="defaultSearchDays">' + '           <input xt-validation-tooltip="" validate="true" msg-min="Value must be between 0 and 365" ' + '               msg-max="Value must be between 0 and 365" placement="top" type="number" pattern="^[0-9]+(\.[0-9]+)*?$" min="0" max="365" ' + '               ng-model="data.value.id" class="{{data.title}} rm-ag-grid-input" container="#workflow-settings-tooltip">' + '       </form>' + '       <form xt-form strategy="submittedOrTouched" ng-switch-when="topFlowMarketThreshold">' + '           <input xt-validation-tooltip="" validate="true" msg-min="Value must be between 0 and 365" msg-max="Value must be between 0 and 365" ' + '               placement="top" type="number" pattern="^[0-9]+(\.[0-9]+)*?$" min="0" max="365" ng-model="data.value.id" ' + '               class="{{data.title}} rm-ag-grid-input" container="#workflow-settings-tooltip">' + '       </form>' + '       <rm-combobox class="{{data.title}}" item-list="data.options" fixed-position="true" ng-model="data.value" ng-switch-default></rm-combobox>' + '</div>';
  };
  var workflowColumnsDef = {
    dashboard: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'dashboard'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    marketAnalysis: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: marketAnalysisCellRenderer,
      cellRendererParams: {
        workflow: 'dashboard'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    demandTransparency: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'demandTransparency'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    flightAnalysis: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: flightAnalysisCellRenderer,
      cellRendererParams: {
        workflow: 'flightAnalysis'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    flightAnalysisPostDeparture: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'flightAnalysisPostDeparture'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    rulesAndStrategies: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'rulesAndStrategies'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    fares: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'fares'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }],
    calibrationAnalysis: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: dashboardCellRenderer,
      cellRendererParams: {
        workflow: 'calibrationAnalysis'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }]
  };
  function getColumnDefs(workflow) {
    var workflowDef = workflowColumnsDef[workflow];
    if (!workflowDef) {
      return false;
    }
    return workflowDef;
  }
  function filterByFeature(entry) {
    if (entry.featureEnable) {
      return FeatureToggleService.isEnabled(entry.featureEnable);
    }
    return true;
  }
  function filterSettingsByFeature(workflowSettings) {
    return _.reduce(workflowSettings, function (result, setting) {
      if (filterByFeature(setting)) {
        setting.options = _.filter(setting.options, filterByFeature);
        result.push(setting);
      }
      return result;
    }, []);
  }
  function getWorkflowSettings(workflow, userDefaults) {
    var settings = _.cloneDeep(workflowData[workflow]);
    if (!settings) {
      return [];
    }
    settings = filterSettingsByFeature(settings);
    _.forEach(userDefaults, function (userSetting) {
      var workflowSetting = _.find(settings, {
        title: userSetting.name
      });
      if (workflowSetting) {
        workflowSetting["default"] = userSetting.value || '';
        workflowSetting.value = {
          id: userSetting.value
        };
      }
    });
    return settings;
  }
  return {
    getColumnDefs: getColumnDefs,
    getWorkflowSettings: getWorkflowSettings
  };
};
WorkflowSettingsConfigService.$inject = ['FeatureToggleService'];
module.exports = WorkflowSettingsConfigService;